import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import UserPreferenceSidebar from './UserPreferenceSidebar';
import api from '../../services/api';
import useAuth from '../../hooks/useAuth';
import './User.css';
import { Form, Button } from 'react-bootstrap';
import APP_CONFIG from '../../config/appConfig';
import ScreenLoader from '../HtmlElements/ScreenLoader';
import Alert from '../HtmlElements/Alert';


export default function ChangePassword() {

  useAuth(); // Ensure the user is authenticated

    const [loader, setLoader] = useState(false);
    const [errors, setErrors] = useState({});
    const [apiError, setApiError] = useState('');
    const [oldpassword, setOldpassword] = useState('');
    const [newpassword, setNewpassword] = useState('');
    const [confirmpassword, setConfirmpassword] = useState('');
    const [error, setError] = useState('');
    const [success_message, setSuccessMessage] = useState('');
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);
    const [oldPasswordError, setOldPasswordError] = useState("")
    const [passwordError, setPasswordError] = useState("")
    const [confirmPasswordError, setConfirmPasswordError] = useState("")

    const toggleShowPassword = () => {
      setShowPassword((prevShowPassword) => !prevShowPassword);
    };

    const regex = /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*\W)(?!.* ).{8,16}$/;
 
    const validatepass = () => {
      // console.log("New password: "+newpassword);
      // console.log("Confirm password: "+confirmpassword);
      if(newpassword.match(regex)) {         
           if(newpassword !== confirmpassword) {               
               setError("Password Don't Match!");
               setSuccessMessage();
               return false;
            } else {
               setError();
               return true;
            }            
      } else {
         setError("Password must be at least one uppercase, one lowercase, one special character and one number!");
         return false;
      }
  }

  const validateOldPassword = () => {
    if(!oldpassword){
      setOldPasswordError("Please enter old password!");
      return false;
    }
    setError();
    setOldPasswordError('');
    return true;
  };

  const validatePassword = () => {
    if(!newpassword){
      setPasswordError("Please enter new password!");
      return false;
    }else if (!newpassword.match(regex)) {
      setPasswordError("Password must be at least one uppercase, one lowercase, one special character, and one number!");
      return false;
    }
    setPasswordError('');
    return true;
  };

  const validateConfirmPassword = () => {
    if (!confirmpassword) {
      setConfirmPasswordError("Please enter confirm password!");
      return false;
    }
    if (newpassword !== confirmpassword) {
      setConfirmPasswordError("Confirm Password does not match New Password!");
      return false;
    }
    setConfirmPasswordError('');
    return true;
  };
  
    const handleSubmit = async (e) => {
      e.preventDefault();
      if(validateOldPassword() && validatePassword() && validateConfirmPassword()){
         try {
          const access_token = localStorage.getItem('access_token');
                   
          const response = await api.post('/users/change_password', { access_token, oldpassword, newpassword});
            
          if(response.data.status == 200) {                
                  setError();
                  //setSuccessMessage(my_data.result.message);
                  setSuccessMessage('Password Changed Succesfully. Please Try to Login now.');
                  sessionStorage.setItem('successMessage', 'Password Changed Succesfully. Please Try to Login now.');
                  navigate('/login');
               } else { 
                  setError(response.data.result.message);
                  //setError("Old Password Not Matching!");
                  setSuccessMessage();      
               }
            
         //navigate('/login');
         } catch (err) {
         setError(err.message || 'Password reset Failed');
         }
      }

    };


  return (
    <div className='user_profile_wrapper pt-4 pb-4'>
      {loader === true && (<ScreenLoader />)}
      <div className='container-fluid'>
        <div className='user_profile_subblock'>
          {error && <Alert type="danger" message={error} />}
          <div className='row'>
            {/* <div className='client_head_left'>
              <h5 className="client_head">Client admin login</h5>
            </div> */}
            {/* <div className='col-md-2' style={{borderRight: "solid 0.1rem #98A4AA33"}}>
              <div className='sidebar_profile'>
                <UserPreferenceSidebar />
              </div>
            </div> */}
            <div className='col-md-10'>
              <div className='userprofile_right' style={{border:'none'}}>
                <div className='row'>
                  <div className="col-md-12">
                      <Form onSubmit={handleSubmit} className="user_form_info" autoComplete='off'>
                        <div className='row'>
                          <div className='col-md-12'>
                            <div className='user_profile_change mb-3'>
                                {/* <div className='img_profile_block'> */}
                                  <h5>Change Password</h5>
                                {/* </div> */}
                            </div>
                          </div>
                          <div className='col-md-6'>
                            <div className="form-control-info mt-0" >
                              <Form.Control
                                type="password"
                                className="form-input"
                                id="oldpassword"
                                placeholder="Please enter Old Password"
                                autoComplete='off'
                                value={oldpassword}
                                onChange={(e) => setOldpassword(e.target.value)}
                                onBlur={validateOldPassword} 
                                // required
                                />
                              <Form.Label className='form-label'>Old Password</Form.Label>
                              {/* {errors.firstname && <div className="text-danger custom_error_msg">{errors.firstname}</div>} */}
                            </div>
                            {oldPasswordError && <div className="text-danger custom_error_msg pt-2">{oldPasswordError}</div>}                            
                          </div>
                          <div className='col-md-6'></div>
                          <div className='col-md-6'>
                            <div className="form-control-info">
                              <Form.Control
                                type={showPassword ? 'text' : 'password'}
                                name="newpassword"
                                className="form-input"
                                value={newpassword}
                                onChange={(e) => setNewpassword(e.target.value)}
                                onBlur={validatePassword}
                                // required
                                // disabled='disabled'
                              ></Form.Control>
                              <Form.Label className='form-label'>New Password <span className='red'>*</span></Form.Label>
                              <div className="input-group-append" style={{'position': 'absolute', 'right': '10px', 'top': '17px', 'zIndex': '5'}}>
                        <span className="" onClick={toggleShowPassword} style={{ cursor: 'pointer' }}>
                          <i className={`fa fa-eye${ showPassword ? '' : '-slash' }`} aria-hidden="true"></i>
                        </span>
                      </div>
                              {/* {errors.newpassword && <div className="text-danger custom_error_msg">{errors.newpassword}</div>} */}
                              
                            </div>
                            {passwordError && <div className="text-danger custom_error_msg pt-2">{passwordError}</div>}
                          </div>

                          <div className='col-md-6'></div>

                          <div className='col-md-6  pb-3'>
                            <div className="form-control-info">
                              <Form.Control
                               type="password"
                               className="form-input"
                               id="password"
                               placeholder="Please enter Confirm Password"
                               autoComplete='off'
                               value={confirmpassword}
                               onChange={(e) => setConfirmpassword(e.target.value)}
                               onBlur={validateConfirmPassword}
                               // required
                                />
                              <Form.Label className='form-label'>Confirm New Password <span className='red'>*</span></Form.Label>
                              {/* {errors.newpassword && <div className="text-danger custom_error_msg">{errors.newpassword}</div>} */}
                              
                            </div>
                            {confirmPasswordError && <div className="text-danger custom_error_msg pt-2">{confirmPasswordError}</div>}
                          </div>

                          <div className="col-md-6"></div>

                          
                          <div className='col-md-6'></div>
                          <div className='col-md-6'></div>
                        </div>

                        <div className='col-md-12 mt-4'>
                          <div className='prev_next_block'>
                            <Button type='button'  className="previous_btn mr-2">
                              Cancel
                            </Button>
                            <Button type='submit' className="personalisation_button">
                              Submit
                            </Button>
                          </div>
                        </div>
                      </Form>
                    </div>
                  </div>
              </div>  
            </div>  
          </div>      
        </div>
      </div>
    </div>


    // <div className="add_user_wrapper">
    //   <div className="container mt-3 p-4">
    //     <h4 className="blue add_user_heading mb-4">Change Password</h4>
    //     <div className='row justify-content-md-center'>
    //       <div className='col-md-12 '>
            
    //         <Form onSubmit={handleSubmit}>
    //         {error && 
    //                  <div className="alert alert-danger">{error}</div>
    //                  }
    //                   {success_message && 
    //                <div className="alert alert-success">{success_message}</div>
    //                   }

    //         <div className="row">
    //             <div className='col-md-6 mb-2'>
    //               <Form.Group controlId="">
    //                 <Form.Label className="form-label custom_label">Old Password <span className='red'>*</span></Form.Label>
    //                 <input
    //                           type="password"
    //                           className="form-control custom_form_control"
    //                           id="oldpassword"
    //                           placeholder="Please enter Old Password"
    //                           autoComplete='off'
    //                           value={oldpassword}
    //                           onChange={(e) => setOldpassword(e.target.value)}
    //                           onBlur={validatepass}
    //                        required/>
    //               </Form.Group>
    //             </div>
    //             </div>
    //             <div className="mb-3 row">
    //             <div className='col-md-6 mb-3'>
    //               <Form.Group controlId="">
    //                 <Form.Label className="form-label custom_label">New Password <span className='red'>*</span></Form.Label>
    //                 <input
    //                           type="password"
    //                           className="form-control custom_form_control"
    //                           id="email"
    //                           placeholder="Please enter your Password"
    //                           autoComplete='off'
    //                           value={newpassword}
    //                           onChange={(e) => setNewpassword(e.target.value)}                              
    //                           onBlur={validatepass}
    //                        required/>
    //               </Form.Group>
    //             </div>
    //             <div className='col-md-6'>
    //               <Form.Group controlId="">
    //                 <Form.Label className="form-label custom_label">Confirm New Password <span className='red'>*</span></Form.Label>
    //                 <input
    //                           type="password"
    //                           className="form-control custom_form_control"
    //                           id="password"
    //                           placeholder="Please enter Confirm Password"
    //                           autoComplete='off'
    //                           value={confirmpassword}
    //                           onChange={(e) => setConfirmpassword(e.target.value)}
    //                           onBlur={validatepass}
    //                        required/>
    //               </Form.Group>
    //             </div>
    //           </div>
    //           <div className='row'>
    //             <div className='col-md-12'>
    //               <Button type="submit" className="btn btn-primary custom_login_btn pull-right">
    //                 Submit
    //               </Button>
    //             </div>
    //           </div>
    //         </Form>
    //       </div>
    //     </div>
    //     </div>
    // </div>

  )
}
